import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import "./Twt.scss";
import translate from "../../../i18n/translate";
import moment from "moment";
import allActions from "../../../redux/actions";
import { Button, Tab, makeStyles, Tabs, ClickAwayListener, Typography } from "@material-ui/core";
import { ITabPanelProps } from "../../../interfaces";
import { allEnglishProductIds, allProducts } from "../../../globalConstants";
import ArrowForwardIosIcon from "@material-ui/icons/ArrowForwardIos";
import ArrowBackIosIcon from "@material-ui/icons/ArrowBackIos";
import CheckIcon from "@material-ui/icons/Check";
import PictureAsPdfIcon from "@material-ui/icons/PictureAsPdf";
import HelpOutlineIcon from "@material-ui/icons/HelpOutline";
import Loader from "../../shared/Loader/Loader";
import Popup from "./Popup";
import ReactGA from "react-ga";
import Moment from "moment-timezone";
import SelectSessions from "./SelectSessions";
import ClassPolicy from "./ClassPolicy/ClassPolicy";
import ErrorPage from "../../shared/ErrorPage/ErrorPage";
import { twtLicenseMappingCheck } from "../../../helpers/twtHelpers";
import { twtLicenseMapper } from "../../../globalConstants";

const Twt: React.FC = () => {
  const useStyles = makeStyles(() => ({
    tab: {
      minWidth: 150,
      "@media (max-width: 320px)": {
        minWidth: 110,
      },
    },
  }));

  let timeZone = Moment.tz.guess(true);
  const classes = useStyles();
  const dispatch = useDispatch();
  const allInfo = useSelector((state: any) => state);
  const [calendarDates, setCalendarDates] = useState<any>({ currrentWeek: [], nextWeek: [] });
  const [isTwtFeatureEnabled, setTwtFeatureEnabled] = useState(false);
  const [userLevel, setUserLevel] = useState("");
  const [loaderFlag, setLoaderFlag] = useState(true);
  const [currentTab, setCurrentTab] = useState({ index: 0, action: "" });
  const [isCurrentWeek, setIsCurrentWeek] = useState(true);
  const [sessions, setSessions] = useState([]);
  const [showClassPolicy, setClassPolicy] = useState(false);
  const [showPopup, setShowPopup] = useState({ state: false, index: -1 });
  const [isLimitReached, setIsLimitReached] = useState(false);
  const scrollToRef = React.useRef<HTMLDivElement>(null);
  const executeScroll = () => scrollToRef?.current?.scrollIntoView({ block: "end", behavior: "smooth" });

  useEffect(() => {
    let currentWeek = [];
    let nextWeek = [];
    for (var i = 0; i <= 13; i++) {
      let day = moment(new Date()).add(i, "days").format("ddd");
      let date = moment(new Date()).add(i, "days").format("DD");
      i <= 6 ? currentWeek.push({ date: date, day: day }) : nextWeek.push({ date: date, day: day });
    }
    setCalendarDates({ currentWeek, nextWeek });
    dispatch(allActions.getTWTTokenAction.getTWTToken());
    startSurveyCheck();
  }, []);

  const startSurveyCheck = async () => {
    if (!!!allInfo.announcements.data) {
      dispatch(allActions.announcementsAction.getAnnouncements(allInfo.common.leuId));
    }
  };

  useEffect(() => {
    !!!allInfo.common.isLoading &&
    !!!allInfo.peopleInformation.isLoading &&
    allInfo.peopleInformation.data &&
    !!!allInfo.getTWTSessions.isLoading &&
    !!!allInfo.getTWTToken.isLoading &&
    !!!allInfo.getLearnerDetails.isLoading
      ? setLoaderFlag(false)
      : setLoaderFlag(true);
  }, [allInfo]);

  useEffect(() => {
    if (!!!allInfo.getTWTSessions.isLoading && !!!allInfo.getTWTSessions.isFailed && !!allInfo.getTWTSessions.data) {
      if (calendarDates.currentWeek) {
        setCurrentTab({ index: 0, action: "change" });
        setSessions(getSessionsList(0, true));
      }
    } else if (!!allInfo.peopleInformation.isFailed) {
      setLoaderFlag(false);
    }
  }, [allInfo.getTWTSessions, calendarDates, userLevel]);

  useEffect(() => {
    if (
      !!!allInfo.common.isLoading &&
      !!!allInfo.common.data &&
      !!!allInfo.peopleInformation.isLoading &&
      !!!allInfo.peopleInformation.isFailed &&
      !!allInfo.peopleInformation.data
    ) {
      initGoogleAnalytics();
      allInfo.peopleInformation.data.getpeopleInformation.serviceConfiguration.features.substring(11, 12) === "1" ? setTwtFeatureEnabled(true) : setTwtFeatureEnabled(false);
      // isTwtUnlimitedFeatureBitOn();
      if (allInfo.getLearnerDetails.data) {
        if (allInfo.getLearnerDetails.data.getLearnerInfo) {
          allInfo.getLearnerDetails.data.getLearnerInfo.Level
            ? setUserLevel(allInfo.getLearnerDetails.data.getLearnerInfo.Level)
            : setUserLevel("");
        }
      } else {
        if (allInfo.peopleInformation.data["getpeopleInformation"]) {
          let productDetails = allInfo.peopleInformation.data.getpeopleInformation.license.find(
            (x: any) => allEnglishProductIds.includes(x.productId) || allProducts.includes(x.productId)
          );
          dispatch(
            allActions.getLearnerDetailsAction.getLearnerDetails(allInfo.common.leuId, Number(productDetails.productId))
          );
        }
      }
    }
  }, [allInfo.common, allInfo.peopleInformation, allInfo.getLearnerDetails]);

  // function isTwtUnlimitedFeatureBitOn() {
  //   if((allInfo.peopleInformation.data.getpeopleInformation.serviceConfiguration.features.substring(80, 81)) === "1") {
  //     setIsLimitReached(false);
  //   } else {
  //     if (!!!allInfo.twtUserTrackHistory.data && !!!allInfo.twtUserTrackHistory.isLoading) {
  //       dispatch(allActions.twtUnlimitedActions.twtUserTrackHistory(allInfo.common.leuId));  
  //     }
  //   }
  // }

  useEffect(() => {
    if(!!allInfo.twtUserTrackHistory.data && allInfo.twtUserTrackHistory.data) {
      setIsLimitReached(!allInfo.twtUserTrackHistory.data);
    }
  }, [allInfo.twtUserTrackHistory]);

  function TabPanel(props: ITabPanelProps) {
    const { children, value, index, ...other } = props;
    return (
      <div
        role="tabpanel"
        className="tab-panel"
        hidden={value !== index}
        id={`simple-tabpanel-${index}`}
        aria-labelledby={`simple-tab-${index}`}
        {...other}
      >
        {value === index && (
          <>
            {children}
          </>
        )}
      </div>
    );
  }

  const initGoogleAnalytics = () => {
    if (allInfo.peopleInformation.data.getpeopleInformation.serviceConfiguration.features.substring(84, 85) === "1") {
      const trackingId: string = process.env.REACT_APP_GA_TRACKING_ID || "";
      ReactGA.initialize(trackingId);
      const url = window.location.pathname;
      ReactGA.set({ page: url });
      ReactGA.pageview(url);
    }
  };

  const getSessionsList = (index: number, getWeek: boolean) => {
    let twtLicenseMapperCheck = twtLicenseMappingCheck(allInfo.peopleInformation.data.getpeopleInformation.license, twtLicenseMapper);
    return allInfo.getTWTSessions.data.filter((element: any) => {
      let currentTime = Moment().tz(timeZone).valueOf();
      let currentWeek = calendarDates[getWeek ? "currentWeek" : "nextWeek"];
      if (calendarDates[getWeek ? "currentWeek" : "nextWeek"].length > 0) {
        let timeToDisplay = Moment(element.startTime).tz(timeZone).add(10, "minutes").valueOf();
        let timeToStart = moment(element.startTime).format("DD") === currentWeek[index].date;
        let matchLevel = element?.classType.levelIds.find((x: any) => (x.cefr === userLevel ? true : false));
        if (matchLevel && currentTime < timeToDisplay) {
          if (timeToStart && twtLicenseMapperCheck.length > 0 && (element?.classType.language.languageCode === twtLicenseMapperCheck[0].language)) return element;
        }
      }
    });
  };

  const handleChange = (event: React.ChangeEvent<{}>, newValue: number) => {
    setCurrentTab({ index: newValue, action: "click" });
    if (!!!allInfo.getTWTSessions.isLoading && !!!allInfo.getTWTSessions.isFailed && !!allInfo.getTWTSessions.data)
      setSessions(getSessionsList(newValue, isCurrentWeek));
  };

  const handleButtonClick = () => {
    const getWeek = isCurrentWeek ? false : true;
    setSessions(getSessionsList(0, getWeek));
    setCurrentTab({ index: 0, action: "change" });
    setIsCurrentWeek(getWeek);
  };

  const handleFaqClick = () => {
    window.open(
      allInfo.common.selectedLanguage === "EN"
        ? `${process.env.REACT_APP_GE_SUPPORT_URL}/EN-EN/solutions/one/twt`
        : `${process.env.REACT_APP_GE_SUPPORT_URL}/${allInfo.common.selectedLanguage}/solutions/one/twt`
    );
  };

  const handleInstructionClick = () => {
    window.open(
      `${process.env.REACT_APP_ASSETS_URL}/halo/twt/twt_${allInfo.common.selectedLanguage.toLowerCase()}.pdf`
    );
  };

  const getTopicTitle = (session: any) => {
    if (session.classType.levelIds) {
      if (session.classType.levelIds.length > 0) {
        let levels = session?.classType.levelIds.slice().sort((a: any, b: any) => a.value - b.value);
        return session?.classType.name + " (" + levels[0].cefr + " - " + levels[levels.length - 1].cefr + ")";
      }
    } else {
      return session?.classType.name + " (Level not available)";
    }
  };

  return (
    <>
      {(isTwtFeatureEnabled && userLevel.length > 0 && !loaderFlag) && 
      <div className="twt-layout">
        <div className="twt-header">
          <div className="twt-title">
            <h3 className="twt_header_text">{translate("twt_talk_with_teacher_title")}</h3>
          </div>
          <div className="twt-sub-header">
            {translate("twt_sub_heading")}
          </div>
          <div className="twt-features-layout">
            <div aria-label="Test" className="twt-features" onClick={() => setClassPolicy(true)}>
              <CheckIcon fontSize="small" className="iconColor"></CheckIcon>
              <div className="feature-name">{translate("class_policy")}</div>
            </div>
            <div className="twt-features" onClick={handleInstructionClick}>
              <PictureAsPdfIcon fontSize="small" className="iconColor"></PictureAsPdfIcon>
              <div className="feature-name">{translate("SessionReport_instructions")}</div>
            </div>
            <div className="twt-features" onClick={handleFaqClick}>
              <HelpOutlineIcon fontSize="small" className="iconColor"></HelpOutlineIcon>
              <div className="feature-name">{translate("Faq")}</div>
            </div>
          </div>
        </div>
        {showClassPolicy && <ClassPolicy setClassPolicy={setClassPolicy}></ClassPolicy> }
        <div className="twt-bodyContainer">
          <div className="twt-Container">
            <div className="twtBlock-parent-header-text">
              <h4 className="ADblock-headertext">{translate("twt_select_sessions")}</h4>
            </div>
            <div className="twtCard-container">
              <SelectSessions isLimitReached={isLimitReached} calendarDates={calendarDates} getWeek={isCurrentWeek} userLevel={userLevel} executeScroll={executeScroll} loaderFlag={setLoaderFlag}/>
              {isLimitReached && (
                <div className="carousel-container">
                  {translate("twt_limit_message")}
                </div>
              )}
            </div>
          </div>
          {showClassPolicy && <ClassPolicy setClassPolicy={setClassPolicy}></ClassPolicy>}
          <div className="twtCalendar-bodyContainer" ref={scrollToRef}>
            <div className="twtCalendar-content">
              <div className="twtCalendar-header">
                <div className="twt-schedule-text">{translate("twt_view_schedule_title")}</div>
                <div className="twt-schedule-actions">
                  {isCurrentWeek ? (
                    <Button
                      color="primary"
                      variant="contained"
                      className="btn-style"
                      size="medium"
                      onClick={handleButtonClick}
                    >
                      {translate("twt_next_week")} <ArrowForwardIosIcon style={{ fontSize: 14 }} />
                    </Button>
                  ) : (
                    <Button
                      color="primary"
                      variant="contained"
                      className="btn-style"
                      size="medium"
                      onClick={handleButtonClick}
                    >
                      {" "}
                      <ArrowBackIosIcon style={{ fontSize: 14 }} />
                      {translate("twt_previous_week")}
                    </Button>
                  )}
                </div>
              </div>
              <hr></hr>
              <div className="calendar-schedule-block">
                <div className="calendar-block">
                  <Tabs
                    value={currentTab.index}
                    onChange={handleChange}
                    indicatorColor="primary"
                    aria-label="simple tabs example"
                    variant="scrollable"
                    scrollButtons="auto"
                  >
                    {calendarDates[isCurrentWeek ? "currentWeek" : "nextWeek"].map(
                      (dates: { date: string; day: string },index:number) => {
                        return <Tab key={index} classes={{ root: classes.tab }} label={dates.date + " " + dates.day} />;
                      }
                    )}
                  </Tabs>
                </div>
                <TabPanel value={currentTab.index} index={currentTab.index}>
                  <div className="levels-block">
                    {sessions.map((session: any, index: number) => {
                      return (
                        <div key={index} className="level-sec all-lvl-time">
                          <p className="level-title">
                            <span className="level-clr"></span>
                            {getTopicTitle(session)}
                          </p>
                          <div className="topic-class">
                            <span className="topic-name">{session?.topic ? session?.topic.name : "Not assigned"}</span>
                            <div className="flex-row-div">
                              <ClickAwayListener onClickAway={() => setShowPopup({ state: false, index: -1 })}>
                                <div className="cls-time">
                                  {session?.topic ? (
                                    <button
                                      className="cls-time-btn"
                                      onClick={() => {
                                        setShowPopup({ state: true, index: index });
                                      }}
                                    >
                                      {moment(session?.startTime).format("HH:mm")}
                                    </button>
                                  ) : (
                                    <div>{translate("twt_topic_unavailable")}</div>
                                  )}
                                  {showPopup.state && showPopup.index === index && <Popup session={session} />}
                                </div>
                              </ClickAwayListener>
                            </div>
                          </div>
                        </div>
                      );
                    })}
                    {sessions.length === 0 && <div className="no-sessions">No sessions available</div>}
                  </div>
                </TabPanel>
              </div>
            </div>
          </div>
        </div>
      </div>
    }
    <Loader showLoader={loaderFlag} /> 
    {(isTwtFeatureEnabled && userLevel.length === 0) && 
      <div className="unassigned-level">
        <Typography variant="h6" className="message-header"> {translate("twt_level_unassigned")} </Typography>
      </div>
    }
    {(!isTwtFeatureEnabled) && <div className="twt-Errorpage"><ErrorPage status={401} /></div>}
    </>
  );
};

export default Twt;
